export default "__VITE_ASSET__8fe7426e__"